// Generated by DesignToCode

import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  ViewChild,
  computed,
  input,
  output,
} from "@angular/core";

export type PrimaryButtonSize = "small" | "medium" | "large";

@Component({
  selector: "app-primary-button",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./primary-button.html",
})
export class PrimaryButton {
  @ViewChild("button") public buttonRegularRef: ElementRef<HTMLElement> | null =
    null;
  public buttonClicked = output<boolean>();

  public size = input<PrimaryButtonSize>("medium");
  public label = input<string>("Coding Challenge");
  public disabled = input<boolean>(false);
  public fullWidth = input<boolean>(false);

  public buttonClasses = computed(() => {
    const classes: string[] = [];

    // Group for child pseudo-class targeting
    classes.push("group");

    // Display
    classes.push("flex");

    // Layout
    classes.push("flex-col", "flex-nowrap", "items-center", "justify-center");

    // Border radius
    classes.push("rounded");

    // Height
    classes.push("h-fit");

    // Width
    if (this.fullWidth()) {
      classes.push("w-full");
    } else {
      classes.push("w-fit");
    }

    if (this.disabled()) {
      // Disabled state
      classes.push(
        "bg-black",
        "opacity-40",
        "cursor-not-allowed",
        "pointer-events-none",
      );
    } else {
      // Default background
      classes.push("bg-black");
      // Hover background
      classes.push("hover:bg-[#1A1A1A]");
      // Active/pressed background
      classes.push("active:bg-[#333333]");
      // Cursor
      classes.push("cursor-pointer");
    }

    // Size-based padding
    if (this.size() === "small") {
      classes.push("pl-4", "pr-4", "pt-2", "pb-2");
    } else if (this.size() === "large") {
      classes.push("pl-10", "pr-10", "pt-4", "pb-4");
    } else {
      classes.push("pl-6", "pr-6", "pt-3", "pb-3");
    }

    return classes;
  });

  public labelClasses = computed(() => {
    const classes: string[] = [];

    // Layout
    classes.push(
      "flex",
      "flex-row",
      "flex-wrap",
      "items-start",
      "justify-start",
    );

    // Dimensions
    classes.push("h-fit", "w-fit");

    // Color — same across all states
    classes.push("text-[#E2E2E2]");

    // Text alignment
    classes.push("text-center");

    // Tracking
    classes.push("tracking-normal");

    // Size-based typography
    if (this.size() === "small") {
      classes.push("text-xs", "font-semibold", "leading-4");
    } else if (this.size() === "large") {
      classes.push("text-base", "font-bold", "leading-6");
    } else {
      classes.push("text-sm", "font-semibold", "leading-5");
    }

    return classes;
  });

  public submit(): void {
    this.buttonRegularRef?.nativeElement.blur();
    this.buttonClicked.emit(true);
  }
}
